.task {
  display: block;
  text-align: left;
  align-items: center;
  padding: 16px;
  justify-content: flex-start;
  text-decoration: none;
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: transform .1s ease;
  position: relative;
}
.bounceTask {
  animation: bounce 1.5s;
}
@keyframes bounce {
  0% {
    transform: translateX(0%);
  }

  30% {
    transform: translateX(25%);
  }

  40% {
    transform: translateX(25%);
  }

  50% {
    transform: translateX(0%);
  }

  60% {
    transform: translateX(7%);
  }

  65% {
    transform: translateX(0%);
  }

  75% {
    transform: translateX(6%);
  }

  85% {
    transform: translateX(0%);
  }

  95% {
    transform: translateX(2%);
  }

  100% {
    transform: translateX(0);
  }
}
.header {
  line-height: 1.5;
  font-size: 16px;
  color: #000;
}
.mark {
  flex: 0 1 16px;
  font-weight: bold;
  font-size: 1rem;
  color: #9e9e9e;
}
.description {
  flex: 0 auto;
  width: 100%;
}
.description__wrapper {
  color: #757575;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.secondaryText p {
  margin: 0;
}
.checkboxWrapper {
  flex: 0 0 24px;
}
.swiperWrapper {
  position: relative;
  overflow: hidden;
  height: 99%;
}
.swiperActions {
  height: 100%;
  min-height: 100%;
  background-color: #f5f5f5;
  display: none;
  align-items: center;
  width: 25%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
.swiperActionsVisible {
  display: flex;
}
.taskButton {
  width: 100%;
  color: white;
  padding: 10px;
  height: 100%;
  text-align: center;
  border: none;
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.taskButton:hover {
  opacity: 1;
}
.closeTaskButton {
  background-color: #66bb6a;
}
.completedTaskButton {
  background-color: #ffab40;
}
.cancelTaskButton {
  background-color: #757575;
}
.pendingTask {
  opacity: 0.5;
}
.highPriorityTask {
  border-left: #ef5350 4px solid;
}
.taskStatus{
  text-align: center;
  font-weight: bold;
  width: 100%;
}
